import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Copy, Sparkles } from 'lucide-react';

export interface PromptListItem {
    id: number;
    slug: string;
    title: string;
    category?: string;
    tool?: string;
    difficulty?: string;
    tags_json?: string;
    caption_pl?: string;
    is_premium: number;
    graphic_url?: string;
    published_at?: string;
    score?: number;
}

const toolLabels: Record<string, string> = {
    chatgpt: 'ChatGPT',
    claude: 'Claude',
    midjourney: 'Midjourney',
    sora: 'Sora',
    gemini: 'Gemini',
    agnostic: 'Każdy AI',
};

const categoryLabels: Record<string, string> = {
    ecommerce: 'E-commerce',
    marketing: 'Marketing',
    'obsluga-klienta': 'Obsługa klienta',
    seo: 'SEO',
    social: 'Social media',
    automatyzacje: 'Automatyzacje',
    analiza: 'Analiza',
    reklamy: 'Reklamy',
};

export const PromptCard: React.FC<{ prompt: PromptListItem; unlocked: boolean }> = ({ prompt, unlocked }) => {
    const isLocked = prompt.is_premium === 1 && !unlocked;
    let tags: string[] = [];
    try { tags = JSON.parse(prompt.tags_json || '[]'); } catch {}

    return (
        <Link
            to={`/prompty/${prompt.slug}`}
            className="group block bg-white dark:bg-gray-900 rounded-2xl shadow-sm hover:shadow-lg transition-all border border-gray-200 dark:border-gray-800 overflow-hidden"
        >
            <div className="aspect-square bg-gradient-to-br from-blue-50 to-violet-100 dark:from-gray-800 dark:to-gray-700 relative flex items-center justify-center">
                {prompt.graphic_url ? (
                    <img src={prompt.graphic_url} alt={prompt.title} className="w-full h-full object-cover" loading="lazy" />
                ) : (
                    <Sparkles className="w-16 h-16 text-blue-300 dark:text-blue-600" />
                )}
                <div className="absolute top-3 right-3">
                    {isLocked ? (
                        <span className="bg-amber-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full flex items-center gap-1">
                            <Lock className="w-3 h-3" /> Premium
                        </span>
                    ) : (
                        <span className="bg-emerald-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
                            Darmowy
                        </span>
                    )}
                </div>
                {prompt.tool && (
                    <span className="absolute top-3 left-3 bg-black/60 text-white text-xs font-medium px-2.5 py-1 rounded-full">
                        {toolLabels[prompt.tool] || prompt.tool}
                    </span>
                )}
            </div>
            <div className="p-5">
                <h3 className="font-bold text-base mb-2 line-clamp-2 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
                    {prompt.title}
                </h3>
                {prompt.caption_pl && (
                    <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-2 mb-3">
                        {prompt.caption_pl}
                    </p>
                )}
                <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400">
                    <span>{categoryLabels[prompt.category || ''] || prompt.category}</span>
                    <span className="flex items-center gap-1 group-hover:text-blue-600 dark:group-hover:text-blue-400">
                        <Copy className="w-3 h-3" /> Otwórz
                    </span>
                </div>
            </div>
        </Link>
    );
};
